/** 1.3.0 portal strings, stream P2 (assignments; email.portal_assignment_new.*, _changed.*, _cancelled.*). P2's file. */
export const ASSIGN_STRINGS = {
  'assign.mediaItem': 'Media',
  'assign.mediaItemDescription': 'The programme or clip itself.',
  'assign.required': 'required',
  'assign.optional': 'optional',
  'assign.noDue': 'no due date',
  'assign.noContact': 'your usual contact',
  'email.portal_assignment_new.subject': 'New delivery requested: {title} ({assetCode})',
  'email.portal_assignment_new.body':
    'Hello {name},\n\n' +
    '{company} has been asked to deliver {title} ({assetCode}) through {portalName}.\n\n' +
    'Due: {due}\n\n' +
    'What to deliver:\n{items}\n\n' +
    'Your contact: {contact}\n\n' +
    'Open the delivery to upload the files: {link}\n',
  'email.portal_assignment_changed.subject': 'Delivery changed: {title} ({assetCode})',
  'email.portal_assignment_changed.body':
    'Hello {name},\n\n' +
    'The delivery of {title} ({assetCode}) on {portalName} has changed.\n\n' +
    'Due: {due}\n\n' +
    'What to deliver now:\n{items}\n\n' +
    'Your contact: {contact}\n\n' +
    'Open the delivery: {link}\n',
  'email.portal_assignment_cancelled.subject': 'Delivery cancelled: {title} ({assetCode})',
  'email.portal_assignment_cancelled.body':
    'Hello {name},\n\n' +
    'The delivery of {title} ({assetCode}) on {portalName} has been cancelled. You don\'t need to upload anything for it.\n',
} as const;
